import React, { useEffect, useState } from 'react';
import { fetchRecords, updateExistingRecord, deleteExistingRecord } from '../api/dataService.js';
import { RECORD_STATUS } from '../config/fieldsConfig.js';
import DataTable from './DataTable';

export default function GenericTab({ dataType, tab, setSelectedRecord, setModalMode, refreshKey, triggerTabRefresh }) {
  const [applications, setApplications] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isBusy, setIsBusy] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    fetchRecords(dataType)
      .then(data => {
        setApplications(data);
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
        alert(`Failed to load ${tab.label || 'records'}.`);
        setIsLoading(false);
      });
  }, [refreshKey, dataType, tab.label]);

  if (isLoading) { return <center><h2>Fetching ... </h2></center>; };

  return (
    <>
      {isBusy && <div className="overlay-banner">Processing...</div>}
      <DataTable
        title={tab.label}
        data={applications}
        fields={tab.fields}
        onView={(record) => {
          setSelectedRecord(record);
          setModalMode("view");
        }}
        onStateChange={ async (record) => {
          console.log( "GenericTab: state change called for:", record );
          if (record.recordStatus === RECORD_STATUS.ACTIVE)
            record.recordStatus = RECORD_STATUS.SNOOZED;
          else
            record.recordStatus = RECORD_STATUS.ACTIVE;
          setIsBusy(true);
          try {
            await updateExistingRecord( record.dataType, record );
          } catch (err) {
            console.error( "Status Change Failed:", err );
            alert( "Status Change Failed:" + err.message );
          } finally {
            setIsBusy(false);
            triggerTabRefresh();
          }
        }}
        onEdit={(record) => {
          setSelectedRecord(record);
          setModalMode("update");
        }}
        onDelete={async (record) => {
          console.log("delete called for:", record);
          if (window.confirm("Are you sure you want to delete this record?")) {
            setIsBusy(true);
            try {
              await deleteExistingRecord( record );
            } catch (err) {
              console.error("Delete failed:", err);
              alert("Delete failed: " + err.message);
            } finally {
              setIsBusy(false);
              triggerTabRefresh();
            }
          }
        }}
      />
    </>
  );
}

